<template>
  <div class="m-activity-seckill-buyerRecord">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="120" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #couponName="{ row }">{{ row.couponName || '---' }}</template>
      <template #couponKind="{ row }">{{ couponTypeMap[row.couponKind] || '---' }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getSendCouponGetRecord } from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
import Table from "@/components/Table/index";
import Search from "@/components/Search/index";

export default {
  name: "marketActivitySeckillBuyerRecord",
  components: {
    AuthButton,
    Table,
    Search
  },
  props: {
  },
  data() {
    return {
      form: {},
      tableKey: false,
      couponTypeMap: {
        'Coupon': '优惠券',
        'GiftCoupon': '礼品券',
        'LotCoupon': '停车券',
      },

      renderData: [
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
      ],
      tableThData: [
        { prop: "couponName", label: "券名称", minWidth: "180", },
        { prop: "couponKind", label: "券类型", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "payTime", label: "发券时间", minWidth: "180", },
        { prop: "source", label: "来源", minWidth: "120", },
      ],
      loading: false,
      tableTrData: [],
      offset: 0,
      limit: 10,
      total: 0,
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        activityId: this.$route.query.id,
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      try {
        const data = await api_getSendCouponGetRecord(params)
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    onSearch() {
      this.offset = 0
      this.getList()
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      if (row.phone_show) {
        delete this.tableTrData[index].phone_show
      } else {
        const {phone} = await api_getUserPhone({id: row.userId})
        this.tableTrData[index].phone_show = aes.decrypt(phone)
      }
      this.tableKey = !this.tableKey
    },

    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },

    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    }

  },
};
</script>

<style lang="scss" scoped>
.m-activity-seckill-buyerRecord {
  box-sizing: border-box;
}
</style>
